import { render, staticRenderFns } from "./cateHeader.vue?vue&type=template&id=79f54097&scoped=true&"
import script from "./cateHeader.vue?vue&type=script&lang=js&"
export * from "./cateHeader.vue?vue&type=script&lang=js&"
import style0 from "./cateHeader.vue?vue&type=style&index=0&id=79f54097&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f54097",
  null
  
)

export default component.exports